export const feature = {
  VIEW_PERSONALIZED: 'ViewPersonalized',
  NEW_FOR_YOU: 'New4You',
  MOST_POPULAR: 'MostPopular',
  OFFERS: 'Offers',
  HISTORY_PERSONALIZED: 'HistoryPersonalized',
}

export const id = {
  VIEW_PERSONALIZED: 'd35244e7-ab72-62d6-3132-0492d8ac3685',
  NEW_FOR_YOU: '6b7a3151-8baf-53ac-eaac-4214834f95c4',
  MOST_POPULAR: 'f0de6b33-e164-59f4-1781-0e0cca61ce79',
  OFFERS: 'b16678f1-4277-bf41-b38e-4281136d1fc5',
  HISTORY_PERSONALIZED: '94f469cf-a12e-5c50-82ce-d76eebbdab90',
}

export const alternativeTitle = {
  ViewPersonalized: 'Visualizados',
  New4You: 'Novidades',
  MostPopular: 'Mais Populares',
  Offers: 'Ofertas',
  HistoryPersonalized: 'Últimos vistos',
  BestSellers: 'Os mais vendidos dos últimos dias',
  SimilarItems: 'Os mais vendidos dos últimos dias',
}

export const alternativeSubtitle = {
  ViewPersonalized: 'Você Visitou',
  New4You: 'Novidades que chegaram pra você',
  MostPopular: 'Campeões em Visualizações da Gazin',
  Offers: 'Produtos que baixaram de preço',
  HistoryPersonalized: 'Relacionados aos seus interesses',
  BestSellers: 'Campeões de Vendas da Gazin',
  SimilarItems: 'Campeões em Visualizações da Gazin',
}

export const showcasesShown = [feature.MOST_POPULAR, feature.NEW_FOR_YOU]
